/**
 * API values that the contract View maps over are sometimes a real array,
 * sometimes a JSON-encoded array string (e.g. clientSignatures: "[]"),
 * and sometimes a non-list (scope: "Full outdoor living installation").
 * Never spread or .map() until the value has passed through here.
 */
export function asArray<T = unknown>(raw: unknown): T[] {
  if (Array.isArray(raw)) return raw as T[];
  if (typeof raw === 'string') {
    const trimmed = raw.trim();
    if (trimmed.startsWith('[')) {
      try {
        const parsed = JSON.parse(trimmed) as unknown;
        if (Array.isArray(parsed)) return parsed as T[];
      } catch {
        /* seed sentences such as contractData.scope stay non-arrays */
      }
    }
    return [];
  }
  return [];
}

/** Object or JSON object string (e.g. project.jobsiteAddress as a JSON blob). */
export function asRecord(raw: unknown): Record<string, unknown> | null {
  if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
    return raw as Record<string, unknown>;
  }
  if (typeof raw === 'string') {
    const trimmed = raw.trim();
    if (trimmed.startsWith('{')) {
      try {
        const parsed = JSON.parse(trimmed) as unknown;
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
          return parsed as Record<string, unknown>;
        }
      } catch {
        /* ignore */
      }
    }
  }
  return null;
}

/** Narrative string fields that seed contracts store where the minted shape uses an array/object. */
export function asText(raw: unknown): string | null {
  if (raw == null) return null;
  if (typeof raw === 'string') {
    const next = raw.trim();
    return next.length ? next : null;
  }
  if (typeof raw === 'number' || typeof raw === 'boolean') {
    return String(raw);
  }
  return null;
}
